import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Ctx = React.createContext({
  subscription: null,
  loading: true,
  refetch: () => {},
  isActive: false,
  isBroker: false,
  isBuilder: false,
  daysLeft: null,
});

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!user) { setSub(null); setLoading(false); return; }
    setLoading(true);
    try {
      const { data } = await api.get("/subscriptions/me");
      setSub(data && data.sub_id ? data : null);
    } catch {
      setSub(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refetch(); }, [refetch]);

  const isActive = !!sub && sub.status === "active";
  const isBroker = isActive && sub.plan === "broker_yearly";
  const isBuilder = isActive && sub.plan === "builder_monthly";
  let daysLeft = null;
  if (sub?.expires_at) {
    daysLeft = Math.max(0, Math.ceil((new Date(sub.expires_at).getTime() - Date.now()) / 86400000));
  }

  return (
    <Ctx.Provider value={{ subscription: sub, loading, refetch, isActive, isBroker, isBuilder, daysLeft }}>
      {children}
    </Ctx.Provider>
  );
}

export const useSubscription = () => React.useContext(Ctx);
